module.exports = __webpack_public_path__ + "img/system_trash@2x.310fd45b.png";